
# DTW #1 - Intro to Down the Whole

2020-01-14

Attendees:
- Owen
- Karl
- Miles
- Louis
- Christian

Announcements:
- updates
- rules
- ~2 min of talk time
- A -> Z
- Why?
  - for the serious bits of conversation that would otherwise not be mentioned because of the normal day to day
  - connect people around the world
  - short list of friends

Meet and Greet:
- Karl
  - (producing vs consuming)
- Owen
  - Rope Hitchcock
- Louis
  - pilot license is the hardest thing he's done
- Miles
  - computer science maybe heading to NYC?
  
Down the Whole #1:
- Pythagorean hammers
- pleasing sounds
- homo deus (allows humans)
- frequencies across cultures
- tribal drums and beats per minute
- alpha wave
- binaural beats
- dogs and cancer patients
- will to live
- how we think about science
- bacteria molecules...?
- mental way? vs physical way?
- twins nature vs nurture
- 3 identical strangers
- nutritional science
- ice cream, high cholesterol
- p-value correlation
- no connection vs connection (when?)
- NYT big links and headlines
- we didn't find a connection vs THERE IS NO CONNECTION
- nothing with humans because there are too many factors
- statistically linked
- titanium vs Karl's favorite metal
- HCP metals and atomic structure
- alloy = mixture of two metals
- magnesium alloys (not flamable)
- titanium, teflon and carbon fiber
- huge database of research
- open access articles?
- aggregate databases?
- Elsevier Database
- DBSCO
- Netflix

Reviews:
- Miles
  - origins?
  - work event and can't talk about work?
  - triggering about x, y, z
  - in tune vs not in tune
  - do we need a prompt?
- Karl
  - format fine
  - sitting in same room would be better
  - talking eclipses?
  - button for next talker?
  - in a room talking
  - NO ORDER
  - no smaller convos
- Louis
  - whoever's talking is easier
- Owen
  - come and go specific session
  - bifurcated

Group think for future:
- happiness
- app idea: other people doing this?
- don't release the podcast but only the notes
- watching baseball vs playing baseball
- having stake in something is better
- CONTROL
  - collaborative discussions
  - google docs for individual convos
  - table poker about topics
  - videogames twitch
  - politus streams
  - git commit async await
  - snapchat stories
  - therapy in person
